import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import memoize from 'fast-memoize';
import { get } from 'lodash';
import { fetchList } from 'services/brands/duck';

class SortedBrandProviderContainer extends Component {
    constructor(props) {
        super(props);

        const memoizeSettings = {
            strategy: memoize.strategies.variadic
        };

        this.sortBrandList = memoize(SortedBrandProviderContainer.sortBrandList, memoizeSettings);
        this.sortBrandAliasList = memoize(SortedBrandProviderContainer.sortBrandList, memoizeSettings);
        this.findBrand = memoize(SortedBrandProviderContainer.findBrand, memoizeSettings);
    }

    componentDidMount() {
        this.props.fetchList();
    }

    static nameSort(a, b) {
        return `${a.name}`.localeCompare(b.name);
    }

    static sortBrandList(brandList = []) {
        return [].concat(brandList).sort(SortedBrandProviderContainer.nameSort);
    }

    static findBrand(brandId, brandList = []) {
        if (brandId) {
            return brandList.find(brand => brand.id === Number(brandId));
        }

        return null;
    }

    render() {
        const brandList = this.sortBrandList(this.props.brandList);

        const brand = this.findBrand(this.props.selectedBrandId, brandList);
        const brandAliases = this.sortBrandAliasList(get(brand, 'BrandAliases'));
        const brandMeta = get(brand, 'meta', null);

        return this.props.children({ brandList, brandAliases, brandMeta });
    }
}

SortedBrandProviderContainer.propTypes = {
    brandList: PropTypes.array,
    children: PropTypes.func,
    selectedBrandId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    fetchList: PropTypes.func
};

const mapStateToProps = state => ({
    brandList: state.brands.list
});

const ConnectedSortedBrandProviderContainer = connect(mapStateToProps, { fetchList })(SortedBrandProviderContainer);

ConnectedSortedBrandProviderContainer.propTypes = {
    children: PropTypes.func.isRequired,
    selectedBrandId: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ])
};

export default ConnectedSortedBrandProviderContainer;



// WEBPACK FOOTER //
// ./src/containers/forms/brands/SortedBrandProviderContainer.js